module.exports = __webpack_public_path__ + "img/no4.27af42e8.png";